import mutations from "./mutations";
import getters from "../getters";
import Cookies from "js-cookie";
import { DataService } from "../../../../config/dataService/dataService";
import { setItem } from "../../../../utility/localStorageControl";
import router from "../../../../routes/protectedRoute";
import { useMessage } from "../../../../composables";

const { successMessage, errorMessage } = useMessage();

const state = () => ({
  login: !!window.localStorage.getItem("access_token"),
  loading: false,
  error: null,
  statusCode: false,
  currentUser: [],
  resErr: null,
  isAdmin: false,
  currentUserData: {
    username: "",
    role: "",
  },
});

const actions = {
  async getCurrentUser({ commit }) {
    try {
      let res = await DataService.get("/auth/me");
    commit("SET_CURRENT_USER", res.data);
    } catch (error) {
      console.error(error);
    }
  },
  async login({ commit }, credLogin) {
    try {
      let res = await DataService.post("/auth/token", {
        username: credLogin.username,
        password: credLogin.password,
        grant_type: "password",
      });

      if (res?.data.status === true) {
        state.statusCode = res.data.status;
        state.currentUser = res.data.user;
        commit("loginBegin");
        Cookies.set("logedIn", true);

        setItem("currentUser", res.data.user);
        setItem("access_token", res.data.access_token);
        commit("loginSuccess", true);
      }

      return res.data;
    } catch (err) {
      commit("loginErr", err);
    }
  },

  async logOut({ commit }) {
    try {
      commit("logoutBegin");
      Cookies.remove("logedIn");
      localStorage.removeItem("currentUser");
      commit("logoutSuccess", null);
      router.push("/auth/login");
    } catch (err) {
      commit("logoutErr", err);
    }
  },

  async logOutUser({ commit }) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("currentUser");
    commit("removeLogged", false);
    Cookies.remove("logedIn");
    router.push("auth/login");
  },

  async resetPasswordCheck(context, data) {
    try {
      let res = await DataService.post("auth/reset-password-check", data);
      if (res.status === 200) {
        successMessage(res.data.message)
        return res.data.token;
      }
      let errMes = res?.data?.detail;
      errorMessage(errMes || "Error can't sent reset password on email")

    } catch (err) {
      errorMessage("Error can't sent reset password on email")
      return false
    }
  },

  async resetPassword(context, data) {
    try {
      let res = await DataService.post("auth/reset-password", {
        new_password: data.new,
        old_password: data.old,
      });
      return res;
    } catch (err) {
      console.error(err);
      return err;
    }
  },

  async resetUserPassword(context, data) {
    try {
      let res = await DataService.post("auth/reset-password-confirm", data);
      if (res.status === 200) {
        successMessage(res.data.message || 'Success changing password')
        return true;
      }
      errorMessage('Token not valid')
      return false;
    } catch (err) {
      console.error(err);
      return false;
    }
  },

  async loginWithLinkedIn({ commit }) {
    try {
      let res = await DataService.get("/auth/linkedin");

      return res;
    } catch (err) {
      commit("loginErr", err);
    }
  },

  async loginWithLinkedInCode({ commit }, data) {
    try {
      let res = await DataService.post("/auth/linkedin/callback", {
        code: data.code,
        state: data,
      });
      if (res?.status === 200) {
        commit("loginBegin");
        Cookies.set("logedIn", true);
      }
      return res;
    } catch (err) {
      commit("loginErr", err);
    }
  },
  async fetchLinkedinData({ commit }, data) {
    try {
      let res = await DataService.get(
        `/auth/linkedin/callback?code=${data.code}&state=${data.state}`
      );
      if (res?.status === 200) {
        router.push("/");

        commit("loginBegin");
        Cookies.set("logedIn", true);
      }
      return res;
    } catch (err) {
      commit("loginErr", err);
    }
  },
  async setCurrent({ commit }, data) {
    commit("SET_CURRENT_USER", data);
  },
};

export default {
  namespaced: false,
  state,
  actions,
  mutations,
  getters,
};
